/**
 * Dto response from migrate user to Local-Auth.
 */
export class MigrateAuthResponseDto {
  status: boolean;

  /**
   * Optional message for the UI
   */
  message?: string;

  /**
   * Error message.
   */
  error: string;

  /**
   * Specifies if user was migrated previously.
   */
  previouslyMigrated: boolean;
}
